import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'button']
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.toggle('hidden', !this.openValue)
    this.menuTarget.classList.toggle('flex', this.openValue)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', this.openValue)
    }
  }

  closeOnResize() {
    if (window.innerWidth >= 1024) {
      this.close()
    }
  }
}
